import { fetchUserAttributes } from 'aws-amplify/auth';
import { extractTrialFieldsFromUser, logTrialDebug } from './trialDebug';

export const enrichUserWithCognitoAttributes = async <T extends Record<string, unknown>>(
  user: T,
): Promise<T> => {
  const jwtFields = extractTrialFieldsFromUser(user);

  try {
    const cognitoAttributes = await fetchUserAttributes();
    const cognitoCustomFields = Object.fromEntries(
      Object.entries(cognitoAttributes).filter(([key]) => key.startsWith('custom:')),
    );

    logTrialDebug('enrichUserWithCognitoAttributes', {
      jwt: jwtFields,
      fetchUserAttributes: cognitoCustomFields,
      willOverrideJwtWithCognito: Object.keys(cognitoCustomFields),
    });

    return {
      ...user,
      ...cognitoAttributes,
    };
  } catch (error) {
    logTrialDebug('enrichUserWithCognitoAttributes failed', {
      jwt: jwtFields,
      error: error instanceof Error ? error.message : error,
    });
    return user;
  }
};
